class Messenger {
  generateMessageMarkup(data) {
    var message = $(`
    <div class="message ${data.status || data?.meta?.status} ${data.user_id == this.user_id && 'user'}" data-id="${data?.id}">
      <span class="message-content">
        <span class="message-body"></span>
        <span class="message-info">
          <span class="date">${data.created_at || global.luxon.DateTime.local().toFormat('HH:mm')}</span>
          <span class="message-status"></span>
        </span>
      </span>
      <button type="button" class="pin-message">
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.7007 0.421256C13.8029 0.421385 13.9041 0.441659 13.9985 0.48092C14.0929 0.52018 14.1786 0.577658 14.2507 0.650065L21.951 8.35036C22.0969 8.49624 22.1789 8.69409 22.1789 8.90039C22.1789 9.10668 22.0969 9.30453 21.951 9.45041C21.203 10.1984 20.2834 10.3656 19.6134 10.3667C19.3373 10.3656 19.092 10.3381 18.8962 10.3051L14.0219 15.1794L14.0549 15.318C14.1385 15.681 14.2331 16.1871 14.2705 16.7547C14.3442 17.8492 14.221 19.3805 13.1507 20.4508C13.0048 20.5967 12.807 20.6787 12.6007 20.6787C12.3944 20.6787 12.1965 20.5967 12.0507 20.4508L7.65048 16.0507L2.70029 21.0009C2.39668 21.3045 0.80382 22.4045 0.500208 22.1009C0.196596 21.7973 1.29664 20.2044 1.60025 19.9008L6.55044 14.9506L2.15027 10.5504C2.0044 10.4046 1.92244 10.2067 1.92244 10.0004C1.92244 9.79413 2.0044 9.59628 2.15027 9.45041C3.22061 8.38006 4.75187 8.25686 5.84531 8.32946C6.377 8.36693 6.90444 8.45049 7.42168 8.57917L12.296 3.70488C12.2555 3.46794 12.2349 3.22803 12.2344 2.98766C12.2355 2.31773 12.4038 1.39699 13.1507 0.650065C13.2228 0.577658 13.3086 0.520181 13.4029 0.48092C13.4973 0.441659 13.5985 0.421385 13.7007 0.421256ZM13.8899 3.70818L13.8888 3.70488L13.8899 3.70818ZM13.8888 3.70488L13.8899 3.70818C13.9347 3.84479 13.9406 3.99113 13.9072 4.13094C13.8738 4.27075 13.8024 4.39857 13.7007 4.50021L8.20051 10.0004C8.09844 10.1025 7.97 10.1741 7.82954 10.2074C7.68908 10.2406 7.54214 10.2341 7.40517 10.1885L7.40298 10.1863L7.38207 10.1808L7.28967 10.1544C6.78443 10.011 6.26578 9.91997 5.74191 9.88272C5.08628 9.83872 4.44276 9.89482 3.91474 10.1148L12.4863 18.6864C12.7063 18.1583 12.7624 17.5148 12.7184 16.8592C12.6791 16.3032 12.5791 15.7533 12.4203 15.219L12.4137 15.1992L12.4115 15.197C12.3659 15.0598 12.3594 14.9126 12.3928 14.7719C12.4263 14.6312 12.4982 14.5026 12.6007 14.4006L18.1009 8.90038C18.2068 8.7936 18.3415 8.71984 18.4885 8.68801C18.6355 8.65619 18.7886 8.66767 18.9292 8.72108C19.1527 8.7789 19.3826 8.80846 19.6134 8.80908C19.7895 8.80908 19.971 8.79258 20.147 8.74638L13.8547 2.45413C13.8107 2.63014 13.7909 2.81055 13.792 2.98766C13.7928 3.22994 13.8253 3.47107 13.8888 3.70488Z"
            fill="white" />
        </svg>
      </button>
    </div>
  `)
    message.find('.message-body').text(data.body);
    return message;
  }
  appendMessage(data) {
    var message = this.generateMessageMarkup(data);
    this.replaceLinks(message.find('.message-body'));
    this.body.append(message)
    this.updateDialog(data);
    this.body.children().not('.message').remove();
    this.scrollable.scrollTop(this.body.height());
    if (data.created_at) {
      this.formatDate(message.find('.date')[0]);
    }
    return message;
  }
  appendPinned(data) {
    var pinned = $(`
      <div class="pinned-el" data-id=${data.id}>
        <div class="p-3">
          <span class="string row-2">${data.body}</span>
        </div>
        <div class="unpin-message">
          <button type="button" class="unpin-btn">
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.1 0.421256C14.2023 0.421385 14.3034 0.441659 14.3978 0.48092C14.4922 0.52018 14.5779 0.577657 14.6501 0.650065L22.3504 8.35036C22.4962 8.49624 22.5782 8.69409 22.5782 8.90039C22.5782 9.10668 22.4962 9.30453 22.3504 9.45041C21.6023 10.1984 20.6827 10.3656 20.0128 10.3667C19.7367 10.3656 19.4914 10.3381 19.2955 10.3051L14.4213 15.1794L14.4543 15.318C14.5379 15.681 14.6325 16.1871 14.6699 16.7547C14.7436 17.8492 14.6204 19.3805 13.55 20.4508C13.4041 20.5967 13.2063 20.6787 13 20.6787C12.7937 20.6787 12.5959 20.5967 12.45 20.4508L8.04981 16.0507L3.09962 21.0009C2.796 21.3045 1.20314 22.4045 0.899531 22.1009C0.595919 21.7973 1.69596 20.2044 1.99957 19.9008L6.94976 14.9506L2.54959 10.5504C2.40372 10.4046 2.32177 10.2067 2.32177 10.0004C2.32177 9.79413 2.40372 9.59628 2.54959 9.45041C3.61994 8.38006 5.15119 8.25686 6.24464 8.32946C6.77633 8.36693 7.30376 8.45049 7.821 8.57917L12.6953 3.70488C12.6548 3.46794 12.6342 3.22803 12.6337 2.98766C12.6348 2.31773 12.8031 1.39699 13.55 0.650065C13.6222 0.577658 13.7079 0.520181 13.8023 0.48092C13.8966 0.441659 13.9978 0.421385 14.1 0.421256Z"
                fill="white" />
            </svg>
          </button>
        </div>
      </div>
    `)
    this.messenger.find('.pinned-el').remove();
    this.messenger.find('.pinned').append(pinned);
    this.replaceLinks(pinned.find('.string'));
  }
  replaceLinks(elem) {
    if (!$(elem)[0]) {
      return;
    }
    var words = $(elem).html().split(' ');
    var re = /((http|https|ftp):\/\/[a-zа-я0-9\w?=&.\/-;#~%-]+(?![a-zа-я0-9\w\s?&.\/;#~%"=-]*>))/g;
    var parsed;
    for (let i in words) {
      if (words[i].match(re)) {
        if (!parsed && $(elem).closest('.message').length) {
          this.parseOpenGraph(words[i], $(elem).closest('.message'));
        }
        words[i] = '<a href="' + words[i] + '" target="_blank">' + words[i] + '</a>';
      }
    }
    $(elem).text('').html(words.join(' '))
    return words.join(' ');
  }
  parseOpenGraph(url, elem) {
    var self = this;
    $.ajax({
      url: 'https://api.microlink.io/?' + $.param({ url }),
      method: 'GET',
      error: null,
      beforeSend: null,
      success: function (data) {
        var body = $(`
        <a href="${url}" target="_blank">
          <div class="text-charcoal my-2 overflow-auto">
            <div class="pinned-name">${data?.data?.title || ''}</div>
            ${data?.data?.image?.url ? `<img class="pinned-img" src="${data?.data?.image?.url}" alt="image" align="left">` : ''}
            <p>${data?.data?.description}</p>
          </div>
        </a>
      `)
        $(elem).find('.message-body').append(body);
        self.scrollable.scrollTop(self.scrollable[0].scrollTop + elem.height());
      }
    })
  }
  addMessageData(message, data) {
    message.attr('data-id', data.id);
    message.removeClass('read unread sending error').addClass(data.status || data?.meta?.status)
    message.find('.date').text(data.created_at);
    this.formatDate(message.find('.date'));
  }
  updateDialog(data) {
    var dialogue = this.messenger.find(`.dialogue[data-chat_id="${data.chat_id}"]`);
    var unreadCounter = dialogue.find('.dialogue-unread');
    if (data.user_id == this.user_id || data.chat_id == this.chat_id) {
      unreadCounter.empty();
    } else {
      const current = parseInt(unreadCounter.text());
      unreadCounter.empty().append(`<span>${current ? current + 1 : 1}</empty>`);
    }
    dialogue.find('.dialogue-preview').text(data.body);
    dialogue.insertBefore($('.dialogue').first());
  }
  formatDate(elem) {
    var date = global.luxon.DateTime.fromISO($(elem).text());
    if (!date.isValid) {
      return;
    }
    var current = global.luxon.DateTime.local();
    if (date.hasSame(current, "day")) {
      $(elem).text(date.toFormat('HH:mm'))
    } else if (date.hasSame(current, "week")) {
      $(elem).text(date.toFormat('ccc HH:mm'))
    } else if (date.hasSame(current, "year")) {
      $(elem).text(date.toFormat('dd LLL HH:mm'))
    } else {
      $(elem).text(date.toFormat('dd.LL.yyyy'))
    }
  }
  loadMessages() {
    var messenger = this;
    if (!messenger.chat_id) {
      return;
    }
    $.ajax({
      method: 'POST',
      accepts: 'text/html',
      url: '/messages/' + messenger.chat_id,
      elem: messenger.messenger,
      data: JSON.stringify({
        page: messenger.page ? messenger.page + 1 : 1,
        last_id: messenger.lastMessageId,
        '_csrf': $('[name="csrf"]').attr('value')
      }),
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        messenger.page = response.messages.meta.current_page;
        if (response.messages.meta.current_page == 1) {
          messenger.lastMessageId = response.messages.data[response.messages.data.length - 1].id;
        }
        messenger.hasMorePages = !!(response.messages.meta.last_page - messenger.page);
        messenger.dialogue.find('.dialogue-unread').empty()
        messenger.body.children().not('.message').remove();
        var messages = $(response.messages.data.reduce(function (acc, cur) {
          return acc + messenger.generateMessageMarkup(cur)[0].outerHTML;
        }, ''));
        messenger.scrollable.scrollTop(2);
        messenger.body.prepend(messages);
        messenger.body.find('.date').each(function () {
          messenger.formatDate(this);
        })
        messenger.form.show();
        if (messenger.page == 1) {
          messenger.scrollable.scrollTop(messenger.body.height());
        }
        if (response.pinned) {
          messenger.appendPinned(response.pinned)
        }
        $('.message-body').each(function () {
          messenger.replaceLinks(this);
        })
      }
    })
  }
  constructor(messenger) {
    const self = this;
    self.body = messenger.find('.chat-field');
    self.scrollable = messenger.find('.chat-body');
    self.form = messenger.find('.form');
    self.messenger = messenger;
    self.chat_id = messenger.find('.dialogue.active').data('chat_id') || undefined;
    self.hasMorePages = messenger.find('.dialogue.active').data('hasmorepages') || undefined;
    self.page = undefined;
    self.lastMessageId = messenger.find('.message').last().data('id') || undefined;
    self.user_id = global.user_id;
    self.dialogue = messenger.find('.dialogue.active');
    self.loadMessages();
    self.scrollable.scrollTop(self.body.height());
    var formatDate = self.formatDate.bind(self);
    var replaceLinks = self.replaceLinks.bind(self);
    $('.date').each(function () {
      formatDate(this);
    })
    $('.message-body').each(function () {
      replaceLinks(this);
    })
    replaceLinks($('.pinned-el').find('.string'));

    self.scrollable.on('scroll', function () {
      if (!self.scrollable[0].scrollTop && self.chat_id && self.hasMorePages) {
        self.loadMessages();
      }
    });

    self.body.on('click', '.message', function (e) {
      e.stopPropagation();
      const message = $(this);
      message.hasClass('pinning') ? message.removeClass('pinning') : message.addClass('pinning');
      self.body.find('.message').not(message).removeClass('pinning');
    })

    self.body.on('click', '.pin-message', function (e) {
      e.stopPropagation();
      const message_id = $(this).closest('.message').data('id');
      $.ajax({
        url: '/messages/pin',
        method: 'POST',
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({ chat_id: self.chat_id, message_id, '_csrf': $('[name="csrf"]').attr('value') }),
        success: function (response) {
          self.appendPinned(response.message);

        },
        elem: null
      })
    })
    self.messenger.on('click', '.unpin-btn', function (e) {
      e.stopPropagation();
      const message_id = $(this).closest('.pinned-el').data('id');
      $.ajax({
        url: '/messages/unpin',
        method: 'POST',
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify({ chat_id: self.chat_id, message_id, '_csrf': $('[name="csrf"]').attr('value') }),
        success: function (response) {
          self.messenger.find('.pinned-el').remove();
        },
        elem: null
      })
    })
    self.messenger.on('click', '.back', function (e) {
      e.stopPropagation();
      self.messenger.find('.dialogue').removeClass('active');
      self.messenger.find('.dialogues').addClass('active');
      self.body.empty().append('<div class="chat-overlay-content">Select chat</div>');
      self.form.hide();
      window.history.replaceState({ html: '' }, "", '/messages');
    })

    self.body.on('click', function (e) {
      const elem = $(this);
      if (elem.closest('.message')[0]) {
        return;
      }
      self.body.find('.message').removeClass('pinning');
    })
    self.messenger.find('.dialogue').on('click', function () {
      self.dialogue = $(this);
      self.chat_id = self.dialogue.data('chat_id')
      self.page = null;
      self.hasMorePages = null;
      self.lastMessageId = null;
      if (self.dialogue.hasClass('active')) {
        return;
      }
      self.messenger.find('.dialogue').removeClass('active');
      self.dialogue.addClass('active');
      self.body.html('<p>start messaging</p>');
      self.form.find('[name="chat_id"]').val(self.chat_id);
      self.form.find('[name="user_id"]').val(self.dialogue.data('user_id'));
      if (!self.chat_id) {
        window.history.replaceState({ html: '' }, "", '/messages/new/' + self.dialogue.data('user_id'));
        return;
      }
      window.history.replaceState({ html: '' }, "", '/messages/' + self.dialogue.data('chat_id'));
      self.messenger.find('.dialogues').removeClass('active');
      self.messenger.find('.dialogue-selected').find('.dialogue-name').text(self.dialogue.find('.dialogue-name').text());
      self.messenger.find('.pinned-el').remove();
      self.loadMessages();

    })

    self.form.find('form').on('keypress', function (e) {
      // if (e.key === "Enter") {
      //   e.preventDefault();
      //   $(this).trigger('submit');
      // }
    })
    validateForm({
      selector: '#chat_form',
      rules: {
        body: {
          required: true,
          normalizer: function (value) {
            return $.trim(value);
          }
        },
      },
      submitHandler: function (form) {
        var elem = $(form);
        var body = elem.find('[name="body"]').val();
        var message = self.appendMessage({ body, chat_id: self.chat_id, user_id: self.user_id, status: 'sending' })
        $.ajax({
          method: 'POST',
          url: elem.attr('action'),
          success: function (response) {
            self.addMessageData(message, { ...response.message, status: 'unread', '_csrf': $('[name="csrf"]').attr('value') });
            $('.chat-textarea').css('height','20px');
          },
          error: function (response) {
            $.ajaxSettings.error(response);
            message.removeClass('sending read unread').addClass('error');
          },
          elem: null,
          data: new FormData(elem[0]),
        })
        elem.trigger('reset');
      }
    })
    self.messenger.on('new:message', function (e, data) {
      if (data.chat_id == self.chat_id) {
        if (self.body.find(`.message.sending`).find(`.message-body:contains("${data.body}")`).length || self.body.find(`.message[data-id="${data.id}"]`).length) {
          return;
        }
        self.appendMessage({ ...data, status: 'read' });
        $.ajax({
          url: '/messages/read',
          method: 'POST',
          contentType: "application/json; charset=utf-8",
          data: JSON.stringify({ chat_id: self.chat_id, '_csrf': $('[name="csrf"]').attr('value') }),
          elem: null,
          complete: null
        })
      } else {
        self.updateDialog(data);
      }
    })
    self.messenger.on('read:chat', function (e, data) {
      if (self.chat_id == data.chat_id) {
        self.body.find('.message').removeClass('unread').addClass('read');
      }
    })

    self.messenger.on('new:chat', function (e, data) {
      window.location.reload();
    })
  }
}


global.modules.set({
  async init(context) {
    var messenger = $('.messanger', context);
    if (messenger[0]) {
      var messenger = new Messenger(messenger);
      let textMessage = $('.chat-textarea');
      if (textMessage) {
        textMessage.on('input', () => {
          textMessage.css('height','20px');
          if (textMessage.get(0).scrollHeight <= 100) {
            textMessage.attr('style', 'height:' + textMessage.get(0).scrollHeight + 'px')
          } else {
            textMessage.css('height','100px');
            
          }
        })
        textMessage.on('focus', () => { })
      }
      // global.messenger = messenger.messenger;
    }
  }
})